<div class="modal-content">
  <h3>{{ title }} <i class="pi pi-times-circle" (click)="close()"></i></h3>
  <p>{{ description }}</p>
</div>
